import styles from './Feature.module.scss';
import WhiteLogo from '../../assets/images/white_logo.png';
import Character1 from '../../assets/images/feature2_1.png';
import Character2 from '../../assets/images/feature2_2.png';
import AppImage from '../../assets/images/feature2_3.png';
import CharacterChip1 from '../../assets/images/feature2_4_1.png';
import CharacterChip2 from '../../assets/images/feature2_4_2.png';
import CharacterChip3 from '../../assets/images/feature2_4_3.png';
import CharacterChip4 from '../../assets/images/feature2_4_4.png';
import useMobile from '../../hooks/useMobile';

const Feature2 = () => {
  const { isMobile } = useMobile();

  if (isMobile)
    return (
      <div className={styles.mobile_wrapper}>
        <div className={styles.text_container}>
          <div className={styles.title}>
            내가 원하는 대로 캐릭터를
            <br />
            만들 수 있다면?
          </div>
          <div className={styles.description}>
            캐릭터를 직접 만들 수 있다면 어떨까요? <br />
            귀엽고 발랄한 친구, 든든한 조언자, 설레는 이상형까지 <br />
            원하는 성격과 모습으로 캐릭터를 설정하고 나만의 <br />
            이야기를 시작해보세요. 단 몇 번의 클릭이면 충분해요. <br />
          </div>
        </div>
        <div className={styles.img_container}></div>
        <img src={Character1} alt="character" className={styles.character2_1} />
        <img src={Character2} alt="character" className={styles.character2_2} />
        <img src={AppImage} alt="app" className={styles.app} />
        <div className={styles.chip_container}>
          <img src={CharacterChip1} alt="chip" className={styles.chip} />
          <img src={CharacterChip2} alt="chip" className={styles.chip} />
          <img src={CharacterChip3} alt="chip" className={styles.chip} />
          <img src={CharacterChip4} alt="chip" className={styles.chip} />
        </div>
      </div>
    );

  return (
    <div className={styles.wrapper}>
      <div className={styles.topper}>
        <img src={WhiteLogo} alt={'parfai'} className={styles.white_logo} />
      </div>
      <div className={styles.container}>
        <div className={styles.title}>
          내가 원하는 대로 캐릭터를
          <br />
          만들 수 있다면?
        </div>
        <div className={styles.description}>
          캐릭터를 직접 만들 수 있다면 어떨까요? <br />
          귀엽고 발랄한 친구, 든든한 조언자, 설레는 이상형까지 <br />
          원하는 성격과 모습으로 캐릭터를 설정하고 나만의 <br />
          이야기를 시작해보세요. 단 몇 번의 클릭이면 충분해요. <br />
        </div>
      </div>
      <div className={styles.container}></div>
      <img src={Character1} alt="character" className={styles.character2_1} />
      <img src={Character2} alt="character" className={styles.character2_2} />
      <img src={AppImage} alt="app" className={styles.app2} />
      <div className={styles.chip_container}>
        <img src={CharacterChip1} alt="chip" className={styles.chip} />
        <img src={CharacterChip2} alt="chip" className={styles.chip} />
        <img src={CharacterChip3} alt="chip" className={styles.chip} />
        <img src={CharacterChip4} alt="chip" className={styles.chip} />
      </div>
    </div>
  );
};

export default Feature2;
